import { render, staticRenderFns } from "./LicenseActive.vue?vue&type=template&id=b560fa3c&scoped=true"
import script from "./LicenseActive.vue?vue&type=script&lang=js"
export * from "./LicenseActive.vue?vue&type=script&lang=js"
import style0 from "./LicenseActive.vue?vue&type=style&index=0&id=b560fa3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b560fa3c",
  null
  
)

export default component.exports